import React, { useEffect, useState } from 'react';

import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';
import { AccountMenu } from '../Presentation';
import { pages } from '@/settings/pages';
import { Loading } from '@/components/utils/Loading';
import { useCheckReAuthenticationExpiration } from '@/hooks/useCheckReAuthenticationExpiration';

export const AccountMenuContainer: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const checkReAuthenticationExpiration = useCheckReAuthenticationExpiration(
    setIsLoading,
    pages.account.index,
  );

  useEffect(() => {
    checkReAuthenticationExpiration();
  }, [checkReAuthenticationExpiration]);

  const admin = useAppSelector(authStore.selectors.meSelector);
  return isLoading ? <Loading /> : <AccountMenu admin={admin} />;
};
